<template lang="">
  <div class="inbanner">
    <img src="@/assets/images/bg_page.png" alt="">
    <div>{{title}}</div>
    <div>{{description}}</div>
  </div>
</template>
<script>
export default {
  props:['title','description']
}
</script>
<style lang="css" scoped>
  .inbanner{
    position: relative;
  }
  .inbanner img{
    width: 100%;
  }
  .inbanner div:nth-child(2){
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-80%);
    color: #FF8B02;
    font-size: 44px;
  }
  .inbanner div:nth-child(3){
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, 55%);
    color: #FF8B02;
    font-size: 20px;
  }
</style>